export default "__VITE_ASSET__b2f7f860__"